<template>
  <b-modal title="Mecânica do Laudo Técnico" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-form-group label-cols="1" label="Mecânica:" label-align="center">
            <b-form-textarea v-model="template.mecanica" rows="8"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Condições Mecânicas</b-alert>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-table bordered hover small :items="template.mecanicos" :fields="fields.item_mecanico"> </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="5">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="2" label-align="right">
            <b-form-input id="descricao" v-model="mecanico.descricao" />
          </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-form-group label="Avaliação:" label-for="avaliacao" label-cols="2" label-align="right">
            <b-form-input id="avaliacao" v-model="mecanico.avaliacao" />
          </b-form-group>
        </b-col>
        <b-col cols="1" class="pl-3 m-0">
          <b-button variant="primary" @click="add()">
            <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
        <b-col cols="1" class="pl-1 m-0">
          <b-button variant="warning" @click="del()">
            <b-icon icon="dash-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Imagens da Inspeção Mecânica</b-alert>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Imagens:" label-cols="2" label-align="right">
            <b-form-file multiple accept=".jpg" v-model="files" placeholder="Solte as imagem aqui .jpg" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-checkbox v-model="template.displayMecanica" name="check-button" switch class="pt-2">
            Exibir Página <b>{{ template.displayMecanica }}</b>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="secondary" @click="show = !show">Cancel</b-button>
      <b-button variant="primary" @click="carregar()">OK</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import LaudoTecnico from "@/models_reports/LaudoTecnico";
import ReportFields from "@/tools/ReportFields";

export default {
  name: "ModalDeLaudoTecnicoMecanica",

  components: {},

  data() {
    return {
      show: false,
      template: new LaudoTecnico(),
      fields: new ReportFields(),
      mecanico: { item: "", descricao: "", avaliacao: "" },
      files: new Array(),
    };
  },

  methods: {
    formatNames(files) {
      return files.length === 1 ? files[0].name : `${files.length} files selected`;
    },

    carregar() {
      for (var i = 0; i < this.files.length; i++) {
        const reader = new FileReader();
        const blob = new Blob([this.files[i]]);
        reader.readAsDataURL(blob);
        switch (i) {
          case 0:
            reader.onload = (e) => {
              this.template.imgFifthPageA = e.target.result;
            };
            break;
          case 1:
            reader.onload = (e) => {
              this.template.imgFifthPageB = e.target.result;
            };
            break;
          case 2:
            reader.onload = (e) => {
              this.template.imgFifthPageC = e.target.result;
            };
            break;
          case 3:
            reader.onload = (e) => {
              this.template.imgFifthPageD = e.target.result;
            };
            break;
        }
      }
      this.show = !this.show;
    },

    add() {
      this.template.mecanicos.push({
        item: this.template.mecanicos.length + 1,
        descricao: this.mecanico.descricao,
        avaliacao: this.mecanico.avaliacao,
      });
    },

    del() {
      if (this.template.mecanicos.length > 0) {
        this.template.mecanicos.pop();
      }
    },

    call(laudo) {
      this.show = !this.show;
      this.template = laudo;
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped></style>
